/**
 * @copyright (C) 2023, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Hyunsu Sim (hssim@rsupport.com)
 *
 * @description
 *
 * @created at Mon Sep 18 2023
 **/

import { colors } from "@/frameworks/core/styles";
import { Theme, css } from "@emotion/react";
import styled from "@emotion/styled";

import {
	Column,
	Row,
	TabContent as TContent,
	TabItem as TItem,
	TypographyCSS,
	Select as DesignStuffSelect,
	Avatar as DesignStuffAvatar,
	Typography
} from "@/frameworks/designStuff/components";
import { hoverScrollCss } from "@/frameworks/designStuff/utils";

export const SettingWrapper = styled(Row)`
	width: 872px;
	@media screen and (max-height: 900px) {
		height: 640px;
	}
	@media screen and (min-height: 900px) {
		height: 868px;
	}
	background: ${({ theme }) => theme.colors.neutral_00_100};
	border-radius: 12px;
`;

export const Wrapper = styled(Column)`
	padding-bottom: 30px;
	width: 100%;
`;

export const ContentArea = styled(Row)`
	flex-grow: 1;
	flex-direction: column;
	gap: 16px;
`;

export const ScrollWrapper = styled(Column)`
	width: 100%;
	${hoverScrollCss()}
`;

export const AvatarArea = styled(Column)``;

export const AvatarWrapper = styled(Row)`
	position: relative;
	width: 86.5px;
	height: 86.5px;

	align-items: center;
	justify-content: center;
`;

export const Avatar = styled(DesignStuffAvatar)`
	transform: scale(1.38);
`;

export const ButtonArea = styled(Row)`
	width: 100%;
`;

export const editButtonStyle = (theme: Theme) => css`
	position: absolute;
	right: 0;
	bottom: 0;
	background-color: ${theme.colors.accent_20_100};
`;

export const VideoContent = styled(Column)`
	width: 100%;
	flex-grow: 1;
`;

export const VideoWrapper = styled(Row)`
	position: relative;
`;
export const DefaultVideoWrapper = styled.div`
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
`;

export const Controller = styled(Row)`
	position: absolute;
	right: 12px;
	top: 12px;
	gap: 8px;
`;

export const Video = styled.video`
	width: 536px;
	height: 302px;
	border-radius: 8px;
	object-fit: cover;
	position: relative;
	background: ${({ theme }) => theme.colors.neutral_90_100};
`;
export const DefaultVideo = styled.div<{ status: "no-cam" | "cam-off" }>`
	display: flex;
	justify-content: center;
	position: absolute;
	align-items: center;
	width: 536px;
	height: 302px;
	border-radius: 8px;
	object-fit: cover;
	background: ${({ theme, status }) =>
		status === "no-cam" ? theme.colors.neutral_30_100 : theme.colors.accent_20_100};
`;

// export const VideoOff = styled.div`
// 	display: flex;
// 	justify-content: center;
// 	align-items: center;
// 	width: 536px;
// 	height: 302px;
// 	border-radius: 8px;
// 	object-fit: cover;
// 	background: ${({ theme }) => theme.colors.accent_20_100};
// `;
export const StyledSelect = styled.select`
	padding: 0 40px 0 12px;
	flex: 1;
	width: 100%;
	height: 40px;
	border: 1px solid #cdd0d6;
	border-radius: 8px;
	appearance: none;
`;

export const GraphicContent = styled(Column)`
	width: 500px;
	flex-grow: 1;
`;

export const DetailWrapper = styled(Column)`
	margin-top: 28px;
	padding-left: 40px;
	width: 100%;
`;

export const DetailContents = styled(Column)`
	padding: 16px 16px 16px 24px;
	width: 100%;
	box-sizing: border-box;
	border-radius: 8px;
	// 해당 색상값 디자인에서 추가 예정 - 임시코드
	background: var(--Neutral_50_8, rgba(135, 139, 147, 0.08));
`;

export const DetailBox = styled(Column)`
	align-items: stretch;
	width: 100%;
`;

export const fullWidth = css`
	width: 100%;
`;

export const Help = styled.p`
	white-space: pre-wrap;
	text-align: start;
	padding-left: 12px;
	${TypographyCSS("Body5", "neutral_60_100")}
`;

export const ContentWrapper = styled(Column)`
	flex-grow: 1;
	width: 100%;

	@media screen and (max-height: 900px) {
		max-height: 510px;
	}
	@media screen and (min-height: 900px) {
		max-height: 820px;
	}
`;

// Language.tsx

export const LanguageSelect = styled(DesignStuffSelect.Select)`
	margin: 4px 0px;
	width: 100%;
	ul {
		height: 420px;
		overflow: auto;
	}
`;

// Account.tsx
export const CheckBoxWrapper = styled(Row)`
	justify-content: space-between;
	gap: 10px;
	padding-top: 8px;
`;

// DeleteAccount.tsx

export const Info = styled.p`
	${TypographyCSS("Body4", "neutral_60_100")}
	word-break: break-all;
	text-align: start;
`;

export const InfoWrapper = styled(Column)`
	width: 100%;
	height: 184px;
	gap: 8px;
	padding: 20px 24px;
	border-radius: 8px;
	background: var(--Neutral_50_8, rgba(135, 139, 147, 0.08));
	margin-top: 10px;
	margin-bottom: 28px;
	/* background-color: ${({ theme }) => theme.colors.neutral_50_80}; 디자인 쪽 색상 코드 추가 중*/
`;

export const InfoLi = styled.li`
	text-align: start;
	list-style: "・";
	${TypographyCSS("Body3", "neutral_60_100")}
`;

export const DeleteSelect = styled(DesignStuffSelect.Select)`
	width: 100%;
	ul {
		padding: 8px;
	}
`;

export const AvatarEditArea = styled(Row)`
	width: 100%;
	height: 86.5px;
	align-items: center;
	justify-content: center;

	gap: 17px;
`;

export const ColorList = styled.ul``;

export const ColorItem = styled.li``;

export const colorTypo = (color: string) => css`
	color: ${color};
`;

export const menuListStyle = (disabled: boolean) => css`
	display: flex;
	width: 325px;
	flex-direction: row;
	gap: 0px;
	align-content: flex-start;
	flex-direction: row;
	flex-wrap: wrap;
	opacity: ${disabled ? 0.4 : 1};

	flex: 1;
`;
// LoginInfo.tsx

export const Th = styled.th`
	${TypographyCSS("Body3_MD", "neutral_70_100")}
	padding: 7px 12px;
`;

export const Td = styled.td`
	${TypographyCSS("Body3", "neutral_60_100")}
	padding:10px 0;
`;
export const THead = styled.thead`
	border-bottom: 1px solid ${({ theme }) => theme.colors.neutral_50_20};
`;

export const buttonIconStyle = (theme: Theme, color: keyof Colors) => {
	return css`
		background: ${theme.colors[color]};
	`;
};

export const RadioWrapper = styled(Row)`
	padding: 2px 24px;
	margin-top: 16px;
	width: 100%;
	justify-content: space-between;
`;

export const SubText = styled(Typography.p)`
	margin-top: 6px;
	padding-left: 32px;
`;
export const AlarmContent = styled(Column)`
	width: 100%;
`;
export const AlarmSection = styled(Row)`
	padding: 8px 0;
	width: 100%;
	justify-content: space-between;
	align-items: center;
`;
export const AlarmContainer = styled(Row)`
	width: 100%;
	align-items: center;
	justify-content: space-between;
`;
export const ChannelItem = styled.li`
	list-style: disc;
	width: 100%;
	&:last-child {
		margin-bottom: 8px;
	}
`;
export const ChannelItemContainer = styled(Row)`
	width: 100%;
	align-items: center;
	justify-content: space-between;
`;
export const ChannelWrapperList = styled(Column.ul)`
	width: 100%;
	gap: 4px;
	padding-left: 38px;
`;

export const ContentBox = styled(Column)`
	padding: 16px;
	width: 100%;
	background: ${colors.neutral_50_8};
	border-radius: 8px;
`;
export const AlarmSubContent = styled(ContentBox)`
	width: 100%;
	background-color: ${colors.neutral_50_8};
	border-radius: 8px;
	padding: 12px 18px;
	margin-bottom: 12px;
`;
export const AlarmSelect = styled(Row)`
	width: 200px;
`;
//SettingContainer.tsx
export const SettingTab = styled(Column)`
	padding: 20px 28px 24px 20px;
	width: 272px;
	height: 100%;
	background: ${({ theme }) => theme.colors.neutral_50_20};
`;
export const SettingContents = styled(Column)`
	padding: 10px 32px 20px;
	overflow: auto;
	gap: 30px;
	flex: 1;
	height: 100%;
	align-items: flex-start;
`;
export const SettingTabItem = styled(Column)`
	width: 100%;
`;
export const TabContent = styled(TContent)`
	display: flex;
	height: 100%;
	align-items: flex-start;
`;
export const tabStyle = css`
	width: 100%;
	align-items: flex-start;
	padding: 0;
`;
export const TabItem = styled(TItem)<{ selected?: boolean; depth?: "two" }>`
	text-align: left;
	border-radius: 8px;
	width: 100%;
	background: ${({ theme, selected }) => (selected ? theme.colors.secondary_80_8 : "initial")};
	> p {
		margin-bottom: ${({ depth }) => (depth === "two" ? "6px" : "initial")};
	}
	p {
		color: ${({ theme }) => theme.colors.neutral_80_100};
		opacity: 1;
	}
	&:hover {
		background: ${({ theme, depth }) => (depth === "two" ? "initial" : theme.colors.secondary_80_8)};
	}
`;
export const tabItemStyle = css`
	padding: 6px 8px;
`;
export const depthWrapperStyle = css`
	opacity: 1;
`;
export const tabTwoDepthItemStyle = css`
	padding: 6px 6px 6px 28px;
`;
// EmojiScrollWrapper.tsx
export const EmojiScrollWrapper = styled(Row)`
	width: 188px;
	height: 164px;
	overflow-x: hidden;
	overflow-y: auto;
	box-shadow:
		0px 8px 16px 0px ${({ theme }) => theme.colors.neutral_20_100},
		0px 0px 4px 0px rgba(0, 0, 0, 0.04);
	background: ${({ theme }) => theme.colors.neutral_00_100};
	border-radius: 12px;
`;
export const EmojiWrapper = styled(Row)`
	padding: 12px;
	width: 188px;
	height: 164px;
	display: grid;
	grid-template-columns: repeat(5, 28px);
	grid-gap: 6px;
`;
export const EmojiItem = styled.img`
	width: 28px;
	height: 28px;
	cursor: pointer;
`;

export const LabelText = styled.p`
	${TypographyCSS("Body4")}
	color: ${({ theme }) => theme.colors.neutral_60_100};
	display: flex;
	align-items: center;
`;
